import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import APITestSingle from "./views/APITestSingle";
import APITestCreate from "./views/APITestCreate";
import APITestCaseCreate from "./views/APITestCaseCreate";
import APITestCaseEdit from "./views/APITestCaseEdit";
import TestCaseLogs from './views/TestCaseLogs';
import Pricing from './views/Pricing';
import Alerts from './views/Alerts';
import Invoices from './views/Invoices';
import Profile from './views/Profile';

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: { 
            requiresAuth: false
        }
    },
    {
        path: "/",
        name: "home",
        component: Home,
        meta: { 
            requiresAuth: true
        }
    },
    {
        path: "/plans/",
        name: "plans",
        component: Pricing,
        meta: { 
            requiresAuth: true
        }
    },
    {
        path: "/alerts/",
        name: "alerts",
        component: Alerts,
        meta: { 
            requiresAuth: true
        }
    },
    {
        path: "/profile/",
        name: "profile",
        component: Profile,
        meta: { 
            requiresAuth: true
        }
    },
    {
        path: "/invoices/",
        name: "invoices",
        component: Invoices,
        meta: { 
            requiresAuth: true
        }
    },
    {
        path: "/test/:test_id/",
        name: "api-test-single",
        component: APITestSingle,
        meta: { 
            requiresAuth: true
        }
    },
    {
        path: "/test/:test_id/test-case/",
        name: "api-test-case-create",
        component: APITestCaseCreate,
        meta: { 
            requiresAuth: true
        }
    },
    {
        path: "/test/:test_id/test-case/:testcase_id/",
        name: "api-test-case-edit",
        component: APITestCaseEdit,
        meta: { 
            requiresAuth: true
        }
    },
    {
        path: "/test/:test_id/test-case/:testcase_id/logs/",
        name: "api-test-case-logs",
        component: TestCaseLogs,
        meta: { 
            requiresAuth: true
        }
    },
    {
        path: "/create/",
        name: "api-test-create",
        component: APITestCreate,
        meta: { 
            requiresAuth: true
        }
    },
  ]
});

router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth)) {
        if (localStorage.getItem('jwt') == null) {
            next({
                path: '/login',
                params: { nextUrl: to.fullPath }
            })
        } else {
            next()
        }
    } else if(to.matched.some(record => record.meta.guest)) {
        if(localStorage.getItem('jwt') == null){
            next()
        }
        else{
            next({ name: 'userboard'})
        }
    }else {
        next() 
    }
})

export default router
